<div class="m-2 m-xl-5">
  <div *ngIf="headerDetails">
    <div class="d-flex align-items-end flex-column justify-content-end w-100">
      <button
        *ngIf="view"
        matTooltip="Guardar"
        matTooltipPosition="above"
        mat-mini-fab
        color="warn"
        (click)="openDialogFunction()"
        [style.visibility]="
          itemsData[itemsData.length - 1]?.itemInventoryId
            ? 'visible'
            : 'hidden'
        "
      >
        <mat-icon>save</mat-icon>
      </button>

      <button
        *ngIf="showReplyButton"
        matTooltip="Regresar"
        class="mt-1"
        mat-mini-fab
        color="primary"
        (click)="replyRouteNavigate()"
      >
        <mat-icon>reply</mat-icon>
      </button>

      <button
        *ngIf="showPrintButton && editHistoryInventory.id"
        mat-mini-fab
        color="accent"
        type="button"
        (click)="print()"
        style="margin-top: 10px"
      >
        <mat-icon>print</mat-icon>
      </button>
    </div>

    <div
      class="firs-row mt-0 d-flex flex-column flex-md-row d-flex align-items-center justify-content-space-evenly col-12 p-0"
    >
      <div class="col-12 col-md-6">
        <combos
          *ngIf="!fromPackOff && addWarehouse"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigWarehouse"
          [required]="true"
          [filter]="true"
          [reloadCombo]="reloadComboWarehouse"
          (changeOptionDataComplete)="valueWarehouse($event)"
          (returnDataCombo)="dataComboWarehouse($event)"
          [dataCombos]="null"
          [disabled]="!view || hasOneWarehouse"
        >
        </combos>

        <combos
          *ngIf="showProvider && addProvider && warehouseId > 0"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigProvider"
          [reloadCombo]="reloadComboProvider"
          [required]="false"
          [filter]="true"
          (changeOption)="valueProvider($event)"
          (returnDataCombo)="dataComboProvider($event)"
          [disabled]="!view"
        >
        </combos>

        <combos
          *ngIf="showPurchaseOrder && comboPurchaseOrder && providerId > 0"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigPurchaseOrderByState"
          [reloadCombo]="reloadComboPurchaseOrderByState"
          [filter]="true"
          [addFinal]="false"
          [additionalData]="firstInRow"
          (changeOption)="changesComboPurchaseOrder($event)"
          (returnDataCombo)="dataComboPurchaseOrder($event)"
        >
        </combos>

        <combos
          *ngIf="comboWorkOrder && (fromPackOff ? true : warehouseId > 0)"
          [disabled]="workOrderState == 3"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigWorkOrderByState"
          [reloadCombo]="reloadComboWorkOrderByState"
          [filter]="true"
          [addFinal]="false"
          [additionalData]="firstInRow"
          (changeOption)="changesComboWorkOrder($event)"
        >
        </combos>

        <combos
          *ngIf="addRentalOrder"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigRentalOrder"
          [reloadCombo]="reloadComboRentalOrder"
          [filter]="true"
          (changeOptionDataComplete)="changesComboRentalOrder($event)"
          (returnDataCombo)="dataComboRentalOrder($event)"
        >
        </combos>
      </div>

      <div class="col-6">
        <app-button-label
          *ngIf="showTotal"
          class="text-center"
          [labels]="labels"
          [ngClass]="addProvider ? 'col-12 col-md-6' : 'col-12'"
        >
        </app-button-label>
      </div>
    </div>

    <div class="default-row mb-3 mt-0">
      <div class="row-item col-6">
        <combos
          *ngIf="addAuthorize"
          class="col-12 col-md-6"
          [configuration]="comboConfigUserAutorize"
          [required]="true"
          [filter]="true"
          (changeOption)="valueUser($event)"
          (returnDataCombo)="dataComboUser($event)"
          [disabled]="!view"
        >
        </combos>
      </div>
      <div class="row-item col-6">
        <mat-form-field *ngIf="addReceptionDate">
          <mat-label>Fecha recepción Tentativa</mat-label>
          <input
            matInput
            [(ngModel)]="receptionDate"
            [matDatepicker]="pickerReception"
            autocomplete="off"
            matInput
            required
            [disabled]="!view"
          />
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="pickerReception">
          </mat-datepicker-toggle>
          <mat-datepicker
            #pickerReception
            [touchUi]="isMobile ? false : true"
          ></mat-datepicker>
          <mat-error>Campo requerido</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div style="display: flex; width: 100%" class="mt-5">
    <div style="flex: 12">
      <cdk-virtual-scroll-viewport
        itemSize="100"
        [ngClass]="acceptButton ? 'example-viewport-50' : 'example-viewport-70'"
      >
        <div
          class="default-row mt-0 mb-3 background-form"
          *ngFor="let element of itemsData; let i = index"
        >
          <div *ngIf="fromPackOff" class="row-item-button">
            <div style="width: 100%">
              <combos
                *ngIf="comboConfigWarehouseByItem[i]"
                [configuration]="comboConfigWarehouseByItem[i]"
                [reloadCombo]="reloadComboWarehouseByItem[i]"
                [required]="true"
                [filter]="true"
                [dataCombos]="comboDataWarehouse"
                (changeOptionDataComplete)="valueWarehouseByItem($event, i)"
              >
              </combos>
            </div>
          </div>

          <div class="row-item-button">
            <div style="width: 100%">
              <combos
                *ngIf="comboConfigItems[i]"
                [configuration]="comboConfigItems[i]"
                [reloadCombo]="reloadComboItems[i]"
                [required]="true"
                [filter]="true"
                [dataCombos]="
                  element.warehouseId
                    ? comboItemsByWarehouse[element.warehouseId] ?? []
                    : comboDataItems
                "
                (changeOption)="valueIDItem($event, i)"
                [disabled]="!view || addRentalOrder"
              >
              </combos>
            </div>
            <div
              *ngIf="addNewItem && view"
              style="min-width: 24px; max-width: 24px; cursor: pointer"
            >
              <div (click)="addNew('item', i)" matRipple>
                <mat-icon>add_circle</mat-icon>
              </div>
            </div>
          </div>

          <div class="row-item" *ngIf="showAmount">
            <mat-form-field>
              <input
                type="number"
                [disabled]="!itemsData[i].itemInventoryId || !view"
                (keyup)="keyUpAmout(i)"
                autocomplete="off"
                step="any"
                min="1"
                matInput
                #cantidad
                required
                [(ngModel)]="itemsData[i].amount"
                oninput="this.value = this.value.slice(0,30)"
                placeholder="Cantidad"
              />
              <mat-error>Campo requerido</mat-error>
              <mat-hint>{{ cantidad.value.length }}/30</mat-hint>
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="isMobile && showCurrentAmount">
            <mat-form-field>
              <input
                autocomplete="off"
                type="text"
                matInput
                #cantidadActual
                [(ngModel)]="itemsData[i].currentAmount"
                disabled
                [readonly]="true"
                oninput="this.value = this.value.slice(0,8)"
                placeholder="Cantidad Inventario"
              />
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="isMobile">
            <mat-form-field>
              <input
                autocomplete="off"
                type="number"
                matInput
                #constItem
                (keyup)="keyUpAmout(i)"
                [(ngModel)]="itemsData[i].costItem"
                [readonly]="false"
                [disabled]="!editCostItem || !view"
                oninput="this.value = this.value.slice(0,30)"
                placeholder="Costo Unidad"
              />
              <mat-hint>{{ constItem.value.length }}/30</mat-hint>
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="isMobile && !fromPackOff">
            <mat-form-field>
              <input
                autocomplete="off"
                type="text"
                matInput
                #unidad
                [(ngModel)]="itemsData[i].code"
                disabled
                [readonly]="true"
                oninput="this.value = this.value.slice(0,30)"
                [placeholder]="labelCodigo"
              />
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="isMobile && showUnitMeasurement">
            <mat-form-field>
              <input
                autocomplete="off"
                type="text"
                matInput
                #unidad
                [(ngModel)]="itemsData[i].unitMeasurement"
                disabled
                [readonly]="true"
                oninput="this.value = this.value.slice(0,30)"
                placeholder="Unidad"
              />
            </mat-form-field>
          </div>

          <button
            *ngIf="itemsData.length > 1 && view && showDeleteItem"
            class="mr-1"
            mat-icon-button
            color="primary"
            (click)="deleteItemsData(i)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="d-flex justify-content-center" *ngIf="view">
          <button
            *ngIf="showRemoveItemButton"
            [style.visibility]="itemsData.length > 0"
            class="mr-1"
            mat-icon-button
            color="primary"
            (click)="deleteItemsData(-1)"
          >
            <mat-icon>remove</mat-icon>
          </button>
          <button
            *ngIf="showAddItemButton"
            [style.visibility]="
              this.itemsData.length == 0 ||
              itemsData[itemsData.length - 1].itemInventoryId
            "
            class="ml-1"
            mat-icon-button
            color="warn"
            (click)="handlerAddForm()"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </cdk-virtual-scroll-viewport>

      <div
        *ngIf="acceptButton"
        style="display: flex; flex-direction: row; justify-content: center"
      >
        <button
          [disabled]="buttonActive"
          (click)="save()"
          style="width: 70%; margin-top: 50px; align-self: center"
          color="primary"
          class="button-save mat-elevation-z5"
          mat-raised-button
          type="submit"
        >
          {{ labelAcceptButton }}
        </button>
      </div>
    </div>
  </div>
</div>
